import './resourceDetails.css';
import { Tabs } from 'antd';
import { TreeViewer, JsonViewer, TextViewer, XmlViewer, ResourceReferences } from '../../componentsIndex';

const ResourceDetails = (props) => {
    const items = [
        {
          key: '0',
          label: `Tree`,
          children: <TreeViewer data={props.resourceListData} />,
        },
        {
          key: '1',
          label: `Text`,
          children: <TextViewer data={props.resourceListData} />,
        },
        {
          key: '2',
          label: `JSON`,
          children: <JsonViewer data={props.resourceListData} />,
        },
        {
          key: '3',
          label: `XML`,
          children: <XmlViewer data={props.resourceListData} />,
        },
        {
          key: '4',
          label: `References`,
          children: <ResourceReferences />,
        }
      ];
    return (
        <Tabs
          defaultActiveKey="0"
          items={items}
          type="card"
        />
    );
}

export default ResourceDetails;